module.exports = __webpack_public_path__ + "img/navImg.12b5ddf5.jpg";